import type { MockRegistration } from '../data/mockRegistrations';
import type { PaymentMethod } from './payment';

/**
 * Registro completo criado pelo usuário no fluxo do sistema.
 *
 * Inclui os campos do mock (`MockRegistration`) + campos só relevantes
 * pra registros locais: dono, hashes fake, método de pagamento, etc.
 *
 * IDs locais sempre seguem o prefixo `tt-99XXXXXX` pra não colidir com
 * os mocks (que vão de `tt-00000001` até `tt-00000200`).
 *
 * `paymentMethod` e `paymentDetailsFake` são opcionais por design:
 *  - Registros antigos no localStorage continuam válidos.
 *  - São campos PRIVADOS — nunca usados em telas públicas (certificado, PDF, /c/:id).
 */
export type Registration = MockRegistration & {
  ownerEmail: string;
  verificationHashFake: string; // "Qm..." 46 chars
  txHashFake: string;            // "0x..." 64 chars
  paymentMethod?: PaymentMethod;
  paymentDetailsFake?: string;
};

export type RegistrationDraft = {
  step: 1 | 2 | 3;
  displayName: string;
  message: string;
  photoDataUrl: string | null;
  consentLgpd: boolean;
  isReady: boolean;
  moderation: {
    status: 'idle' | 'pending' | 'approved' | 'rejected';
    reason?: string;
  };
};

export const emptyDraft = (): RegistrationDraft => ({
  step: 1,
  displayName: '',
  message: '',
  photoDataUrl: null,
  consentLgpd: false,
  isReady: false,
  moderation: { status: 'idle' },
});
